import { registerLoginPage } from './loginPage.js';

registerLoginPage({
  kasir: window.LOGIN_ROUTES?.kasir,
  creator: window.LOGIN_ROUTES?.creator,
});
